var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-banner',{staticClass:"mb-3",attrs:{"icon":"mdi-account-star","single-line":"","elevation":"1","color":"white"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("buttons")]},proxy:true}],null,true)},[_vm._t("text")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }